<div
  class="flex flex-col h-[100vh] w-full bg-gradient-to-b from-[#025590] via-[#025590] to-[#338FA9]"
>
  <div class="flex grow gap-4 overflow-hidden">
    <!-- Sidebar -->
    <div
      class="flex flex-col transition-all duration-300"
      [ngClass]="isSidebarExpanded ? 'w-[250px]' : 'w-[80px]'"
    >
      <div class="flex p-3 items-center gap-4"></div>
      <div class="flex items-center justify-between p-2">
        <a
          class="flex items-center hover:bg-primary-100/60 cursor-pointer p-2 rounded-xl"
          matRipple
          href="/landing"
          *ngIf="isSidebarExpanded"
        >
        
          <img src="assets/landing/logo.svg" alt="Navigate to Landing" />
      </a>
        <div
          class="flex items-center hover:bg-primary-100/60 cursor-pointer p-2 rounded-xl"
          matRipple
          (click)="toggleSidebar()"
        >
          <img src="assets/images/sidebar-left.png" alt="Toggle Sidebar" />
        </div>
      </div>

      <div class="flex p-3 items-center gap-4"></div>
      <div class="border-t pt-8">
        <div class="flex flex-col justify-between mt-3">
          <div
            class="pl-3 text-white text-sm font-bold"
            *ngIf="isSidebarExpanded"
          >
            <p>Main menu</p>
          </div>
          <!-- Menu Items -->
          <div class="flex flex-col gap-1 pl-0">
            <ng-container *ngFor="let menu of menuItems; let i = index">
              <ng-container *ngxPermissionsOnly="menu?.permission">
                <div
                  [routerLink]="menu?.route"
                  matTooltip="{{ menu?.name }}"
                  matTooltipPosition="right"
                  routerLinkActive="bg-white !text-black dark:bg-gray-800 dark:text-white"
                  class="flex flex-row w-full overflow-hidden gap-2 items-center justify-center p-2 rounded-r-full cursor-pointer text-white"
                >
                  <ng-container *ngIf="menu.icon">
                    <mat-icon
                      *ngIf="menu.iconType == 'SVG'"
                      [svgIcon]="menu.icon"
                      class="!h-8 !w-8 opacity-80 transition-all duration-300"
                    ></mat-icon>
                    <mat-icon
                      *ngIf="menu.iconType == 'MAT'"
                      class="opacity-80 transition-all duration-300"
                      >{{ menu.icon }}</mat-icon
                    >
                  </ng-container>
                  <div
                    class="grow overflow-hidden whitespace-nowrap text-ellipsis"
                    *ngIf="isSidebarExpanded"
                  >
                    {{ menu?.name | titlecase }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>


<div class="flex-grow"></div>
  <div class=""></div> 
        <div class="flex p-3 items-center gap-4"></div>

 


    </div>

    

    <!-- Content Section -->
    <!-- Content Section -->
<div class="flex-grow flex flex-col overflow-y-scroll w-[320px] bg-[#F7F7F7] p-4 min-w-0">
  <app-top-nav-bar [isDrawable]="true" (drawerToggle)="toggleState()" [currentState]="currentState"></app-top-nav-bar>
  <div class="mt-12"></div>
  <router-outlet></router-outlet>
</div>
  </div>
</div>
